import * as React from 'react'
import { IOption, IProviderProps } from '@user/components/Filters'

import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { useQuery } from 'react-query'
import { AgreementType } from './typings'

export const AgreementStatusProvider: React.FC<IProviderProps> = ({
  render,
}) => {
  const { data: agreementTypes, isLoading } = useQuery(
    ['filters', 'agreementStatuses'],
    async () => {
      const response = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'leads',
          'agreementStatuses',
        )}`,
      )

      const types: AgreementType[] = await response.json()
      // remove falsey (null) values
      return types.filter(Boolean)
    },
  )

  const agreementTypeOptions: IOption[] = React.useMemo(
    () =>
      agreementTypes
        ? agreementTypes.map(({ id, name }) => ({ label: name, value: id }))
        : [],
    [agreementTypes],
  )

  return <>{render(agreementTypeOptions, isLoading)}</>
}
AgreementStatusProvider.displayName = 'AgreementStatusProvider'
